<template>
  <div class="personal-center">
    <!-- logo 菜单 -->
    <div class="logo_box">
      <div class="head_box container">
        <div class="shop_logo" v-if="isShopView">
          <router-link to="/" target="_blank">
            <img v-if="shopInfo.logoFilePath" class="img_item" :src="shopInfo.logoFilePath" alt />
            <h1 v-else class="com_hover">{{shopInfo.name}}</h1>
          </router-link>
        </div>
        <div class="logo" v-else>
          <router-link to="/" target="_blank">
            <img class="img_item" src="@/assets/img/LOGO.png" alt />
          </router-link>
          <h1>买家具多比·多比多实惠</h1>
        </div>
        <div class="my_duobi">个人中心</div>
        <div class="page_index" v-if="!isIndexPage">
          <a class="color_000" href="/personalCenter/personIndex" target="_self">首页</a>
        </div>
        <el-dropdown class="drop" v-else>
          <span class="el-dropdown-link">
            首页
            <i class="el-icon-arrow-down el-icon--right cur_pointer"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a :href="orderPath" target="_self">订单中心</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="drop mar0">
          <span class="el-dropdown-link">
            账户设置
            <i class="el-icon-arrow-down el-icon--right cur_pointer"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a href="/personalCenter/userBind" target="_self">账户绑定</a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a href="/personalCenter/shipAddress" target="_self">收货地址</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="search_box">
          <el-input placeholder="商品关键词搜索" v-model="searchKey" @keyup.enter.native="searchKeyWords">
            <i slot="suffix" class="el-input__icon el-icon-search cur_pointer" @click="searchKeyWords"></i>
          </el-input>
        </div>
      </div>
    </div>
    <!--个人中心内容部分-->
    <div class="personal-content container">
      <div class="content">
        <order-router v-if="showRouter"></order-router>
        <!-- 新开页面 可以嵌套 -->
        <router-view class="action-view"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import OrderRouter from "./components/orderRouter";
export default {
  components: {
    OrderRouter,
  },
  props: {
    isShopView: {
      type: Boolean,
      default: false,
    },
    categoryPath: {
      type: String,
      default: "/category",
    },
    orderPath: {
      type: String,
      default: "/personalCenter/myOrder",
    },
  },
  data() {
    return {
      searchKey: "",
      isIndexPage: true,
      showRouter: true,
      shopInfo: {},
    };
  },
  mounted() {
    this.shopInfo = this.$store.state.shopInfo;
    // 新开页面 初始化
    let path = this.$route.path.toLowerCase();
    if (path === "/personalCenter/personIndex".toLowerCase()) {
      this.isIndexPage = true;
    } else {
      // this.isIndexPage = false;
    }
    // 若有详情页 注意平台订单详情也要加入到判断逻辑
    let path1 = "/personalCenter/myOrderDetail".toLowerCase();
    let path2 = "/personalCenter/shopOrderDetail".toLowerCase();
    if (path.indexOf(path1) !== -1 || path.indexOf(path2) !== -1) {
      this.showRouter = false;
    } else {
      this.showRouter = true;
    }
  },
  methods: {
    searchKeyWords() {
      this.searchKey = this.searchKey ? this.searchKey.trim() : undefined;
      let newUrl = this.$router.resolve({
        path: this.categoryPath,
        query: { searchKey: this.searchKey },
      });
      window.open(newUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.personal-center {
  .logo_box {
    border-bottom: 1px solid @themeColor;
  }
  .head_box {
    margin-top: 37px;
    padding-bottom: 43px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
    .shop_logo {
      padding-left: 45px;
      .img_item {
        width: auto;
        height: 67px;
      }
      h1 {
        font-size: 24px;
        color: #000000;
      }
    }
    .my_duobi {
      color: #000000;
      font-size: 24px;
      font-weight: 500;
    }
    .page_index {
      color: #000000;
      font-size: 20px;
      font-weight: 500;
      .color_000 {
        color: #000000;
      }
    }
    .drop {
      color: #000000;
      font-size: 20px;
      font-weight: 500;
      &:hover {
        color: @themeColor;
        .el-icon-arrow-down {
          transform: rotate(180deg);
          -ms-transform: rotate(180deg); /* IE 9 */
          -moz-transform: rotate(180deg); /* Firefox */
          -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
          -o-transform: rotate(180deg); /* Opera */
        }
      }
    }
    .search_box {
      width: 388px;
      .el-input {
        border: 1px solid @themeColor;
        /deep/ .el-input__suffix {
          font-size: 24px;
        }
      }
    }
    .mar0 {
      margin-right: 0px;
    }
  }
  .content {
    padding: 25px 0px 15px;
    display: flex;
    .action-view {
      width: calc(100% - 160px);
    }
  }
}
.el-dropdown-menu {
  a {
    color: #606266;
  }
}
</style>